import styled from "styled-components";
import { Button } from "../../../base/buttons/button/index.js";
import { Icon } from "../../../base/icons/icon/index.js";
import { FlexMixin } from "../../../../styles/common/mixins/helpers.styled.js";
export const ArrayInputWrapper = styled.div.withConfig({
    displayName: "styled__ArrayInputWrapper",
    componentId: "sc-92e189c4-0"
})`
	position: relative;
	${FlexMixin({
    direction: 'column'
})};
	gap: 16px;

	padding-bottom: 56px;

	${({ theme  })=>theme.media.up('lg')} {
		padding-bottom: 0;
		padding-right: 176px;
	}

	${({ theme  })=>theme.media.up('xl')} {
		padding-right: 0;
	}
`;
export const ArrayInputRow = styled.div.withConfig({
    displayName: "styled__ArrayInputRow",
    componentId: "sc-92e189c4-1"
})`
	position: relative;
	${FlexMixin()};
	gap: 16px;
`;
export const ArrayInputRowContent = styled.div.withConfig({
    displayName: "styled__ArrayInputRowContent",
    componentId: "sc-92e189c4-2"
})`
	${FlexMixin()};
	gap: 16px;
	flex: 1 1 100%;
	max-width: 100%;
`;
export const AddButton = styled(Button).withConfig({
    displayName: "styled__AddButton",
    componentId: "sc-92e189c4-3"
})`
	position: absolute;
	bottom: 0;
	left: 0;
	background: transparent;
	width: 160px;

	${({ theme  })=>theme.media.only('xs')} {
		position: relative;
		margin: auto;
		width: 100%;
	}

	${({ theme  })=>theme.media.up('lg')} {
		bottom: calc((56px - 40px) / 2);
		right: 0;
		left: unset;
	}

	${({ theme  })=>theme.media.up('xl')} {
		width: 150px;
		bottom: unset;
		top: 0;
	}
`;
export const RemoveIcon = styled(Icon).withConfig({
    displayName: "styled__RemoveIcon",
    componentId: "sc-92e189c4-4"
})`
	${FlexMixin({
    align: 'center',
    justify: 'center'
})};
	cursor: pointer;
	padding: 16px;

	${({ disabled  })=>disabled ? `
        opacity: 0.5;
		visibility: hidden;
        cursor: not-allowed;
    ` : ''}
`;

//# sourceMappingURL=styled.js.map